import { render, staticRenderFns } from "./AnalyticsScreen.vue?vue&type=template&id=5fc1c17c"
import script from "./AnalyticsScreen.vue?vue&type=script&lang=ts"
export * from "./AnalyticsScreen.vue?vue&type=script&lang=ts"
import style0 from "./AnalyticsScreen.vue?vue&type=style&index=0&id=5fc1c17c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QCard,QSelect,QItem,QItemSection});
